import { Checkbox } from '@mui/material';
import { useEffect, useState } from 'react';
import { Info } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import {
  FamilyMemberStyled,
  FamilyMemberItemTextStyled,
} from './FamilyMemberStyled';
import { displayDependentAvatar } from 'enrollment/features/Family/FamilyDetailsPage/components';
import { TooltipWrapper } from 'enrollment/components/Shared/TooltipWrapper';

export interface FamilyMemberProps {
  isYou?: boolean;
  name?: string;
  age?: number;
  selected?: boolean;
  id?: number;
  onChangeKey?: string;
  profile?: any;
  disabled?: boolean;
  hideCheckbox?: boolean;
  qmcso?: boolean;
  onChange?: (id?: number) => void;
  onChangeWithKey?: (key?: string) => void;
}

export const FamilyMember = ({
  isYou,
  hideCheckbox,
  name,
  age,
  selected,
  id,
  onChangeKey,
  profile,
  qmcso,
  disabled = false,
  onChange,
  onChangeWithKey,
}: FamilyMemberProps) => {
  const { t } = useTranslation('common');
  const [checked, setCheckedState] = useState(selected);

  useEffect(() => {
    setCheckedState(selected);
  }, [selected]);

  const handleFamilyMemberClick = () => {
    if (!isYou) {
      setCheckedState(!checked);
      if (onChange) {
        onChange(id);
      } else if (onChangeWithKey) {
        onChangeWithKey(onChangeKey);
      }
    }
  };
  const dependentFirstName = name || profile?.first_name;

  return (
    <FamilyMemberStyled
      $hideCheckBox={isYou || hideCheckbox}
      className=""
      data-testid="family-member-wrapper"
    >
      {isYou || hideCheckbox ? null : (
        <Checkbox
          id={`checkBox-${onChangeKey ? onChangeKey : id}`}
          checked={checked}
          disabled={disabled}
          onClick={handleFamilyMemberClick}
          data-testid="family-member-checkbox"
        />
      )}
      <div className="d-flex align-items-center">
        {displayDependentAvatar(profile, 30)}
        <label
          htmlFor={`checkBox-${onChangeKey ? onChangeKey : id}`}
          className="my-0"
        >
          <FamilyMemberItemTextStyled data-testid="family-member-text">
            {isYou ? 'You' : dependentFirstName}
            {age ? ` (${age})` : ''}
            {qmcso && (
              <TooltipWrapper
                position="auto"
                tooltipContent={t('common:qmcsoValidation')}
                allowWrap={true}
              >
                <button className="bg-white">
                  <Info className="mx-1 mb-1" size={20} />
                  <span className="sr-only">{t('common:qmcsoValidation')}</span>
                </button>
              </TooltipWrapper>
            )}
          </FamilyMemberItemTextStyled>
        </label>
      </div>
    </FamilyMemberStyled>
  );
};
